module.exports = __webpack_public_path__ + "img/invite.77547108.png";